export const SEARCH_INTERNAL = "Internal";
export const SEARCH_HYBRID = "Hybrid";
export const SEARCH_EMR = "EMR";